const DSN = import.meta.env.VITE_SENTRY_DSN;
const ENV = import.meta.env.MODE;

let initialized = false;
let sentryClient = null;

export function initErrorReporting() {
  if (initialized) return;
  initialized = true;

  window.addEventListener("unhandledrejection", e => {
    reportError(e.reason || new Error("Unhandled rejection"), { kind: "unhandledrejection" });
  });

  if (!DSN) return;

  import("@sentry/react")
    .then(Sentry => {
      sentryClient = Sentry;
      Sentry.init({
        dsn: DSN,
        environment: ENV,
        tracesSampleRate: ENV === "production" ? 0.1 : 0,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: ENV === "production" ? 1.0 : 0,
      });
    })
    .catch(err => {
      if (ENV !== "production") console.warn("[errorReporting] Sentry failed to load", err);
    });
}

export function reportError(error, context = {}) {
  if (ENV !== "production") console.error("[reportError]", error, context);
  sentryClient?.captureException?.(error, { extra: context });
}
